import { render } from "./OrderGateway.vue?vue&type=template&id=44c870b7"
import script from "./OrderGateway.vue?vue&type=script&lang=js"
export * from "./OrderGateway.vue?vue&type=script&lang=js"

import exportComponent from "/Users/louis/Dev/source/ec/ec-food-frontend/cardholder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__